import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

const SnackbarAlert = ({ open, message, severity = "error", onClose, autoHideDuration = 6000 }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ maxWidth: "600px", width: "90%" }}
    >
      <Box sx={{ width: "100%" }}>
        <Alert
          onClose={onClose}
          severity={severity}
          sx={{
            width: "100%",
            fontSize: "1rem",
            padding: "12px 20px",
            "& .MuiAlert-icon": { fontSize: "1.5rem" },
            "& .MuiAlert-action": { paddingTop: "2px" },
          }}
        >
          {message}
        </Alert>
        <LinearProgress
          variant="determinate"
          value={100}
          sx={{
            animation: `progress ${autoHideDuration}ms linear`,
            "@keyframes progress": {
              from: { width: "100%" },
              to: { width: "0%" },
            },
          }}
        />
      </Box>
    </Snackbar>
  );
};

export default SnackbarAlert;